<template>
    <div style="height: 100vh;overflow-y: auto;overflow-x: hidden">
        <div>
            <img src="../../../static/images/bg.png" style="width: 100%;height: 80%"/>
        </div>
        <div style="width: 100%;height: 100vh">
            <div style="font-size: 30px;width: 100%;text-align: center;margin-top: 40%">
                <van-icon name="passed" color="#67C23A" size="2em"/>
            </div>
            <div style="font-size: 30px;width: 100%;text-align: center;line-height: 70px">
                提交成功
            </div>
        </div>
    </div>
</template>

<script>
    import img from '@/assets/images/bg.png';

    export default {
        data() {
            return {
                areaList: areaList,
                townList: [],
                img: img,

            };
        },
        created() {

        },
        methods: {},
    };
</script>

<style>
    .van-cell {
        padding: 10px 16px 10px 28px;
        font-size: 17px;
    }
</style>

<style scoped>
    .red {
        color: #F56C6C;
    }
</style>



// WEBPACK FOOTER //
// src/view/base/finish.vue